module.exports = __webpack_public_path__ + "img/1 (14).cb1eba3e.png";